"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _WordCount = _interopRequireDefault(require("composer-lib/components/composer/WordCount"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save
  };
};

var WordCountContainer = (0, _createReactClass.default)({
  displayName: "WordCountContainer",
  propTypes: {
    auth: _propTypes.default.instanceOf(_Auth.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    useLineHeight: _propTypes.default.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      useLineHeight: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        composition = _this$props.composition,
        lock = _this$props.lock,
        saveState = _this$props.saveState,
        useLineHeight = _this$props.useLineHeight;
    var noEdit = (0, _lockHelpers.compositionLocked)(lock, auth, saveState) || composition.isReadOnly();
    return _react.default.createElement(_WordCount.default, {
      editorState: saveState.content,
      noEdit: noEdit,
      useLineHeight: useLineHeight
    });
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, {})(WordCountContainer);

exports.default = _default;
module.exports = exports.default;